import { render, staticRenderFns } from "./BuyBoxRow.vue?vue&type=template&id=193be0ee&scoped=true"
import script from "./BuyBoxRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./BuyBoxRow.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BuyBoxRow.vue?vue&type=style&index=0&id=193be0ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193be0ee",
  null
  
)

export default component.exports